module.exports = __webpack_public_path__ + "img/ddc4bce.png";